import { useState } from 'react';
import { Button } from 'react-bootstrap';

/**
 * Travel insurance claim help
 */
export function TravelInsurance() {
  const [haveInsurance, setHaveInsurance] = useState<boolean>();

  return (
    <div className="my-4">
      <h6 className="mb-4">Do you have travel insurance?</h6>

      <Button
        className="me-1 mb-1"
        onClick={() => setHaveInsurance(true)}
        variant={haveInsurance === true ? 'primary' : 'outline-primary'}
      >
        Yes
      </Button>

      <Button
        className="mb-1"
        onClick={() => setHaveInsurance(false)}
        variant={haveInsurance === false ? 'primary' : 'outline-primary'}
      >
        No
      </Button>

      {haveInsurance === true && (
        <>
          <p className="mt-4">
            It's worth reaching out to them to see if you can make a claim under
            your policy. To do this, please confirm your cancellation first at
            the bottom of this page.
          </p>

          <p>
            After doing that, you can head over to your dashboard, click on your
            booking, and then click on the "print invoice" button under the
            "Invoice" section. This will help you print an invoice that you can
            send to your insurer, in order to make a claim.
          </p>
        </>
      )}

      {haveInsurance === false && (
        <>
          <p className="mt-4">
            Whilst we always advise to take out insurance well in advance of the
            trip, we do appreciate you may not have got around to that yet. In
            this case it's worth checking in case you have any annual travel
            insurance policy, but otherwise please proceed to the next section.
          </p>
        </>
      )}
    </div>
  );
}
